<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="100px">
				<el-form-item label="角色名称：" prop="group_name">
					<el-input class="input" v-model="form.group_name" placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="角色配置：">
					<div class="col">
						<el-tree :data="rulesList" show-checkbox default-expand-all node-key="id" ref="tree"
							highlight-current :props="defaultProps" :default-checked-keys='form.rules'>
						</el-tree>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		roleRules,
		roleAdd,
		roleEdit,
		roleDetail
	} from "../../../request/apis.js"
	export default {
		props: {
			type: {
				type: Number
			}
		},
		components: {
			Tip
		},
		data() {
			return {
				title: '编辑新增',
				rulesList: [],
				defaultProps: {
					children: 'children',
					label: 'title'
				},
				form: {
					group_name: '',
					rules: []
				},
				rules: {
					group_name: [{
							required: true,
							message: '请输入角色名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 6,
							message: '长度在6个字符内',
							trigger: 'blur'
						}
					]
				}
			}
		},
		computed: {},
		mounted() {
			if (this.type != -1) {
				//详情编辑
				this.form.group_id = this.type
				this.getRoleDetail();
			}
			this.getRoleRules();
		},
		methods: {

			//获取详情
			getRoleDetail() {
				roleDetail({
					group_id: this.form.group_id
				}).then(res => {
					if (res.code == 0) {
						this.form.group_name = res.data.group_name;
						this.form.rules = res.data.rules;
					}
				}).catch(err => {})
			},

			//获取权限列表
			getRoleRules() {
				roleRules().then(res => {
					if (res.code == 0) {
						this.rulesList = res.data
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
			},

			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
                        this.form.rules = [...this.$refs.tree.getHalfCheckedKeys(),...this.$refs.tree.getCheckedKeys()];
						if (this.type != -1) {
							//编辑
							roleEdit({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
								}
							}).catch(err => {})
						}else{
							//新增
							roleAdd({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
								}
							}).catch(err => {})
						}
						
					} else {
						return false;
					}
				});

			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.col {
		display: flex;
		flex-direction: column;
		margin-top: 7px;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 600px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>